module.exports = __webpack_public_path__ + "static/media/close.efd71c8c.svg";